import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { farmers, images } from "../../config/images";
import {
  Grid,
  Box,
  Button,
  Dialog,
  DialogContent,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Backdrop,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Menu,
  Stack,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import "./Farmer.css";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import PreviewFarmersDetails from "./PreviewFarmersDetails";
import translations from "../../config/language";

const Farmers = () => {
  const navigate = useNavigate();

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filterAnchor, setFilterAnchor] = useState(null);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [isPreviewClick, setIsPreviewClick] = useState(false);
  const [selectedFarmer, setSelectedFarmer] = useState(null);

  const [filterValues, setFilterValues] = useState({
    status: "",
    timePeriod: "",
    fromDate: "",
    toDate: "",
    location: "",
    farmingCategory: "",
    infrastructure: "",
    gender: "",
    region: "",
  });
  const open = Boolean(isFilterOpen);
  // Open Filter Popup
  const handleFilterClick = (event) => {
    setFilterAnchor(event.currentTarget); // Set filter icon position
    setIsFilterOpen(true);
  };

  const handleClose = () => {
    setIsFilterOpen(false);
  };

  const handleFilterChange = (field) => (event) => {
    setFilterValues({
      ...filterValues,
      [field]: event.target.value,
    });
  };

  const handleClear = () => {
    setFilterValues({
      status: "",
      timePeriod: "",
      fromDate: "",
      toDate: "",
      location: "",
      farmingCategory: "",
      infrastructure: "",
      gender: "",
      region: "",
    });
  };

  const farmerData = [
    {
      id: 1,
      photo: farmers.farmerImage1,
      farmerName: "Jones Scott Jone",
      date: "17/01/2025",
      dataCollector: "Jones Scott Jone",
      mobileNumber: "+234 9876 5432",
      location: "8 My Street, Ilassan Lekki, Lagos..",
      status: "Pending",
    },
    {
      id: 2,
      photo: farmers.farmerImage2,
      farmerName: "Scott Jones Lee",
      date: "16/01/2025",
      dataCollector: "Jones Scott Jone",
      mobileNumber: "+234 9876 5433",
      location: "8 My Street, Ilassan Lekki, Lagos..",
      status: "Pending",
    },
    {
      id: 3,
      photo: farmers.farmerImage1,
      farmerName: "Jones Scott Jone",
      date: "17/01/2025",
      dataCollector: "Jones Scott Jone",
      mobileNumber: "+234 9876 5432",
      location: "8 My Street, Ilassan Lekki, Lagos..",
      status: "Pending",
    },
    {
      id: 4,
      photo: farmers.farmerImage2,
      farmerName: "Scott Jones Lee",
      date: "17/01/2025",
      dataCollector: "Jones Scott Jone",
      mobileNumber: "+234 9876 5433",
      location: "8 My Street, Ilassan Lekki, Lagos..",
      status: "Approved",
    },
    {
      id: 5,
      photo: farmers.farmerImage1,
      farmerName: "Jones Scott Jone",
      date: "17/01/2025",
      dataCollector: "Jones Scott Jone",
      mobileNumber: "+234 9876 5432",
      location: "8 My Street, Ilassan Lekki, Lagos..",
      status: "Pending",
    },
    {
      id: 6,
      photo: farmers.farmerImage2,
      farmerName: "Scott Jones Lee",
      date: "17/01/2025",
      dataCollector: "Jones Scott Jone",
      mobileNumber: "+234 9876 5433",
      location: "8 My Street, Ilassan Lekki, Lagos..",
      status: "Pending",
    },
    {
      id: 7,
      photo: farmers.farmerImage1,
      farmerName: "Jones Scott Jone",
      date: "17/01/2025",
      dataCollector: "Jones Scott Jone",
      mobileNumber: "+234 9876 5432",
      location: "8 My Street, Ilassan Lekki, Lagos..",
      status: "Pending",
    },
    {
      id: 8,
      photo: farmers.farmerImage2,
      farmerName: "Scott Jones Lee",
      date: "17/01/2025",
      dataCollector: "Jones Scott Jone",
      mobileNumber: "+234 9876 5433",
      location: "8 My Street, Ilassan Lekki, Lagos..",
      status: "Pending",
    },
    {
      id: 9,
      photo: farmers.farmerImage1,
      farmerName: "Jones Scott Jone",
      date: "17/01/2025",
      dataCollector: "Jones Scott Jone",
      mobileNumber: "+234 9876 5432",
      location: "8 My Street, Ilassan Lekki, Lagos..",
      status: "Reject",
    },
    {
      id: 10,
      photo: farmers.farmerImage2,
      farmerName: "Scott Jones Lee",
      date: "17/01/2025",
      dataCollector: "Jones Scott Jone",
      mobileNumber: "+234 9876 5433",
      location: "8 My Street, Ilassan Lekki, Lagos..",
      status: "Pending",
    },
    {
      id: 11,
      photo: farmers.farmerImage1,
      farmerName: "Jones Scott Jone",
      date: "17/01/2025",
      dataCollector: "Jones Scott Jone",
      mobileNumber: "+234 9876 5432",
      location: "8 My Street, Ilassan Lekki, Lagos..",
      status: "Pending",
    },
    {
      id: 12,
      photo: farmers.farmerImage2,
      farmerName: "Scott Jones Lee",
      date: "17/01/2025",
      dataCollector: "Jones Scott Jone",
      mobileNumber: "+234 9876 5433",
      location: "8 My Street, Ilassan Lekki, Lagos..",
      status: "Reject",
    },
  ];

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };
  const [filteredData, setFilteredData] = useState(farmerData);
  const handleFilterSubmit = () => {
    let filtered = farmerData;

    // Filter by Status
    if (filterValues.status) {
      filtered = filtered.filter(
        (item) =>
          item.status.toLowerCase() === filterValues.status.toLowerCase()
      );
    }

    // Filter by Date Range
    if (filterValues.fromDate && filterValues.toDate) {
      const fromDate = new Date(filterValues.fromDate);
      const toDate = new Date(filterValues.toDate);
      filtered = filtered.filter((item) => {
        const itemDate = new Date(item.date);
        return itemDate >= fromDate && itemDate <= toDate;
      });
    }

    setFilteredData(filtered);
    handleClose(); // Close filter popup
  };

  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));

  const handlePreviewClick = (farmer) => {
    setSelectedFarmer(farmer);
    setIsPreviewClick(true);
  };

  const language = process.env.REACT_APP_LANGUAGE;
  return (
    <>
      {!isPreviewClick && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box className="task-assign-box">
              <Box
                className="d-flex justify-content-between align-items-center"
                style={{ flexWrap: "wrap" }}
              >
                <Box
                  className="d-flex gap-3 img-box"
                  style={{ padding: "25px" }}
                >
                  <img src={farmers.farmerIcon} alt="" />
                  <Typography variant="h6" gutterBottom>
                    {translations[language].farmersList}
                  </Typography>
                </Box>
                <div className="edit-profile">
                  <img src={farmers.excelSheetIcon} alt="" />
                  <img src={farmers.pdfIcon} alt="" />
                  <div>
                    <img
                      src={farmers.filterIcon}
                      alt=""
                      onClick={handleFilterClick}
                    />
                  </div>
                </div>
              </Box>

              <Box style={{ width: "100%", overflowX: "auto" }}>
                <Table className="task-assign-table farmer-table">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{textAlign: "center"}}>{translations[language].srNo}</TableCell>
                      <TableCell>{translations[language].photo}</TableCell>
                      <TableCell>{translations[language].farmerName}</TableCell>
                      <TableCell>{translations[language].date}</TableCell>
                      <TableCell>{translations[language].dataCollectorName}</TableCell>
                      <TableCell>{translations[language].mobileNo}</TableCell>
                      <TableCell>{translations[language].location}</TableCell>
                      <TableCell>{translations[language].statusView}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredData.map((farmer, index) => (
                      <TableRow key={farmer.id}>
                        <TableCell style={{textAlign: "center"}}>{index + 1}</TableCell>
                        <TableCell>
                          <img
                            src={farmer.photo}
                            alt="Farmer"
                            className="farmer-photo"
                          />
                        </TableCell>
                        <TableCell>{farmer.farmerName}</TableCell>
                        <TableCell>{farmer.date}</TableCell>
                        <TableCell>{farmer.dataCollector}</TableCell>
                        <TableCell>{farmer.mobileNumber}</TableCell>
                        <TableCell>{farmer.location}</TableCell>
                        <TableCell className="farmer-table-body-row-cell status-view-cell">
                          <div className="d-flex gap-2 justify-content-between">
                            <span
                              className="status-text"
                              style={{
                                color:
                                  farmer.status.toLowerCase() === "approved"
                                    ? "#31A05F"
                                    : "black",
                              }}
                            >
                              {farmer.status}
                            </span>
                            <img
                              src={images.viewIcon}
                              alt=""
                              className="view-icon"
                              onClick={() => handlePreviewClick(farmer)}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
              <Box display="flex" justifyContent="end" alignItems="center">
                <Stack spacing={2} className="mb-2">
                  <CustomPagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                  />
                </Stack>
              </Box>
              {/* Filter Popup */}
              <Dialog
                open={isFilterOpen}
                onClose={handleClose}
                className="filter-popup"
                maxWidth="xs"
                fullWidth
                disableScrollLock
                PaperProps={{
                  sx: { borderRadius: "12px" },
                }}
              >
                <DialogContent style={{ padding: "10px" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 0,
                      mt: 0,
                    }}
                  >
                    <Typography variant="h6">Filter</Typography>
                    <Button onClick={handleClear} sx={{ color: "#666" }}>
                      {translations[language].clear}
                    </Button>
                  </Box>

                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    <FormControl fullWidth size="small">
                      <Select
                        value={filterValues.status}
                        onChange={handleFilterChange("status")}
                        displayEmpty
                        IconComponent={ArrowDropDownIcon}
                        className="filter-select"
                      >
                        <MenuItem value="" hidden>
                          {translations[language].selectStatus}
                        </MenuItem>
                        <MenuItem value="approved">{translations[language].approved}</MenuItem>
                        <MenuItem value="pending">{translations[language].pending}</MenuItem>
                        <MenuItem value="reject">{translations[language].reject}</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl fullWidth size="small">
                      <Select
                        value={filterValues.timePeriod}
                        onChange={handleFilterChange("timePeriod")}
                        displayEmpty
                        IconComponent={ArrowDropDownIcon}
                        className="filter-select"
                      >
                        <MenuItem value="" hidden>
                          {translations[language].selectTimePeriod}
                        </MenuItem>
                        <MenuItem value="today">{translations[language].today}</MenuItem>
                        <MenuItem value="week">{translations[language].week}</MenuItem>
                        <MenuItem value="month">{translations[language].month}</MenuItem>
                        <MenuItem value="year">{translations[language].year}</MenuItem>
                      </Select>
                    </FormControl>

                    <div style={{ display: "flex", gap: 1 }}>
                      <TextField
                        size="small"
                        placeholder={translations[language].fromDate}
                        value={filterValues.fromDate}
                        onChange={handleFilterChange("fromDate")}
                        InputProps={{
                          endAdornment: (
                            <CalendarTodayIcon
                              sx={{ color: "#666", fontSize: 20 }}
                            />
                          ),
                        }}
                      />
                      <TextField
                        size="small"
                        placeholder={translations[language].toDate}
                        value={filterValues.toDate}
                        onChange={handleFilterChange("toDate")}
                        InputProps={{
                          endAdornment: (
                            <CalendarTodayIcon
                              sx={{ color: "#666", fontSize: 20 }}
                            />
                          ),
                        }}
                      />
                    </div>

                    <FormControl fullWidth size="small">
                      <Select
                        value={filterValues.location}
                        onChange={handleFilterChange("location")}
                        displayEmpty
                        IconComponent={ArrowDropDownIcon}
                        className="filter-select"
                      >
                        <MenuItem value="" hidden>
                          {translations[language].selectLocation}
                        </MenuItem>
                        <MenuItem value="location1">Location 1</MenuItem>
                        <MenuItem value="location2">Location 2</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl fullWidth size="small">
                      <Select
                        value={filterValues.farmingCategory}
                        onChange={handleFilterChange("farmingCategory")}
                        displayEmpty
                        IconComponent={ArrowDropDownIcon}
                        className="filter-select"
                      >
                        <MenuItem value="" hidden>
                          {translations[language].selectFarmingCategory}
                        </MenuItem>
                        <MenuItem value="category1">Category 1</MenuItem>
                        <MenuItem value="category2">Category 2</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl fullWidth size="small">
                      <Select
                        value={filterValues.infrastructure}
                        onChange={handleFilterChange("infrastructure")}
                        displayEmpty
                        IconComponent={ArrowDropDownIcon}
                        className="filter-select"
                      >
                        <MenuItem value="" hidden>
                          {translations[language].selectInfrastructureProximity}
                        </MenuItem>
                        <MenuItem value="close">Close</MenuItem>
                        <MenuItem value="far">Far</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl fullWidth size="small">
                      <Select
                        value={filterValues.gender}
                        onChange={handleFilterChange("gender")}
                        displayEmpty
                        IconComponent={ArrowDropDownIcon}
                        className="filter-select"
                      >
                        <MenuItem value="" hidden>
                          {translations[language].selectGender}
                        </MenuItem>
                        <MenuItem value="male">{translations[language].male}</MenuItem>
                        <MenuItem value="female">{translations[language].female}</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl fullWidth size="small">
                      <Select
                        value={filterValues.region}
                        onChange={handleFilterChange("region")}
                        displayEmpty
                        IconComponent={ArrowDropDownIcon}
                        className="filter-select"
                      >
                        <MenuItem value="" hidden>
                          {translations[language].selectRegion}
                        </MenuItem>
                        <MenuItem value="region1">Region 1</MenuItem>
                        <MenuItem value="region2">Region 2</MenuItem>
                      </Select>
                    </FormControl>
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={handleFilterSubmit}
                      sx={{
                        backgroundColor: "#31A05F",
                        "&:hover": {
                          backgroundColor: "#2b8f54",
                        },
                      }}
                    >
                      {translations[language].submit}
                    </Button>
                  </Box>
                </DialogContent>
              </Dialog>
            </Box>
          </Grid>
        </Grid>
      )}

      {isPreviewClick && (
        <PreviewFarmersDetails
          isPreviewClick={isPreviewClick}
          setIsPreviewClick={setIsPreviewClick}
          selectedFarmer={selectedFarmer}
        />
      )}
    </>
  );
};

export default Farmers;
